<template>
    <div class="content share">
        <div class="imgCanvas" id="imgCanvas">
            <img src="../../assets/images/share.png" class="bg">
            <van-row style="background-color: #fff;padding: .3rem .45rem;box-sizing: border-box;width: 5.76rem;height: 2.21rem;position: absolute;bottom: .15rem;left: .16rem;box-shadow:0px -5px 10px 0px rgba(83,113,227,0.17);overflow: hidden;">
                <van-col style="width: 3.43rem;">
                    <p style="font-size: .24rem;color: #606266;">
                        <span>限时<font color="#FF0000">0.06</font>折&nbsp;&nbsp;&nbsp;&nbsp;原价<font color="#FF0000" style="text-decoration:line-through">1469</font>元</span>
                    </p>
                    <p style="color: #3D7EFF;font-size: .42rem;margin: .13rem 0;"><strong>99元即可试用</strong></p>
                    <p style="color: #606266;font-size: .2rem;"><span>-长按识别二维码申请试用-</span></p>
                </van-col>
                <van-col style="width: 1.43rem;box-sizing: border-box;" id="qrcode">
                    <!-- <img src="../../assets/images/download.png" style="width: 100%;"> -->
                </van-col>
            </van-row>
            <img :src="src" id="canvas" v-show="src!=''" style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;width: 100%;height: 100%;border:none;">
        </div>
        <div class="shareFoot">
            <p style="padding-top: 2rem;">
                <span>长按图片，保存并转发到好友、微信群、朋友圈</span>
            </p>
        </div>
    </div>
</template>
<script>
    // import {} from '../../api';
    import {getOpenId} from '../../api';
    import html2canvas from 'html2canvas';
    import QRCode from 'qrcodejs2';
    export default {
        name: 'share',
        data() {
            return {
                src:"",
                weixinInfo:{},
                wxConfig:{
                    appid:"wx9fc68a7bac8f1258",
                    url:location.href.split('#').toString()
                }
            }
        },
        methods: {
            getQueryString(name){
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
                var r = window.location.search.substr(1).match(reg); 
                if (r != null) return decodeURI(r[2]); return ""; 
            },
            init(){
                var that = this;
                var qrcode = new QRCode(document.getElementById('qrcode'), {
                    text: window.location.origin+"/apply?openid="+that.weixinInfo.openid+"&&nickname="+that.weixinInfo.nickname,
                    width: 100,
                    height: 100,
                    colorDark : '#000000',
                    colorLight : '#ffffff',
                    correctLevel : QRCode.CorrectLevel.H
                });
                setTimeout(function(){
                    html2canvas(document.getElementById("imgCanvas"),{useCORS:true}).then(canvas => {
                        that.src=canvas.toDataURL("image/jpeg",1.0);
                    });
                },2000);
            }
        },
        mounted(){
            // this.init();
            var that = this;
            if(that.getQueryString("code")==null||that.getQueryString("code")==""){
                var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+that.wxConfig.appid+"&" + "redirect_uri=" + encodeURIComponent(that.wxConfig.url) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
                window.location.href = url;
            }else{
                getOpenId("?code="+that.getQueryString("code")).then(function(res) {
                    if (res.code==1) {
                        that.weixinInfo = res.data;
                        that.init();
                    }else{
                        that.$toast(res.message)
                    }
                })
            }
    	}
	}
</script>
<style type="text/css">
    .share {
        background-color: #fff;
    }
    .share img {
        border:none;
    }
    .share .imgCanvas {
        position: relative;
        width: 6.08rem;
        height: 11.62rem;
        overflow: hidden;
        margin: auto;
        background-color: transparent;
    }
    .share .imgCanvas .bg {
        width: 100%;
    }
    .share .shareFoot {
        background-image: url(../../assets/images/share1.png);
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: left bottom;
        width: 100%;
        height: 3.21rem;
        margin-top: -1.5rem;
        text-align: center;
        font-size: .28rem;
        color: #fff;
        font-weight: bold;
    }
    .share #qrcode img {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/apply/share.vue


// WEBPACK FOOTER //
// src/views/apply/share.vue